import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { firestorGetDoc } from '../firebase';
import { AppThunk } from '../store';
import { NftStats, Rarity, RarityCounts } from '../types/nft';



interface StatsState {
  rarity: RarityCounts;
  traits: NftStats;
  loading: boolean;
  loaded: boolean;
}

const initialState: StatsState = {
  traits: {},
  rarity: {
    [ Rarity.Common ]: 0,
    [ Rarity.Uncommon ]: 0,
    [ Rarity.Rare ]: 0,
    [ Rarity.Epic ]: 0,
    [ Rarity.Legendary ]: 0,
  },
  loading: false,
  loaded: false,
}


const service = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>): StatsState {
      return { ...state, loading: action.payload, }
    },
    setLoaded(state): StatsState {
      return { ...state, loaded: true, }
    },
    setTraits(state, action: PayloadAction<NftStats>): StatsState {
      return { ...state, traits: { ...action.payload }, }
    },
    setRarity(state, action: PayloadAction<RarityCounts>): StatsState {
      return { ...state, rarity: { ...action.payload }, }
    },
  }
});



const load = (): AppThunk => async (dispatch, getState) => {
  if (getState().stats.loaded) {
    return;
  }
  
  try {
    dispatch(service.actions.setLoading(true));
    const rarity = await firestorGetDoc<RarityCounts>('stats', [ 'rarity' ])
    const traits = await firestorGetDoc<NftStats>('stats', [ 'traits' ])

    rarity && dispatch(service.actions.setRarity(rarity));
    traits && dispatch(service.actions.setTraits(traits));

  }
  catch (e) {
    console.error(e);
  }
  finally {
    dispatch(service.actions.setLoading(false));
    dispatch(service.actions.setLoaded());
  }
}


export const actions = {
  load,
}

export default service.reducer;